import React from 'react'
import Tags from '@yaireo/tagify/dist/react.tagify'
import '../../../shared-css/tagify.css'

function TagField({
  label,
  enumType,
  name,
  onAdd,
  onRemove,
  initialValue = [],
  className = '',
  isEditable = true,
}: any) {
  const handleChange = (e: any) => {
    console.log('===e', e)
    if (e.type === 'add') {
      onAdd(e.detail.data.value, e.detail.data.__tagId, enumType, true)
    } else if (e.type === 'edit:updated') {
      //edited the existing data if its has id
      if (e.detail.data.id) {
        //pass the id
        onAdd(
          e.detail.data.value,
          e.detail.data.id,
          enumType,
          false,
          e.detail.data.id,
          e.detail.previousData.__originalData.value
        )
      } else {
        //pass the previoustagid as id
        console.log('e.detail', e.detail)
        onAdd(
          e.detail.data.value,
          e.detail.previousData.__tagId,
          enumType,
          false,
          e.detail.data.__tagId,
          e.detail.previousData.__originalData.value
        )
      }
    }
  }

  const handleRemove = (e: any) => {
    //check for newly added data or not
    if (e.detail.data.id) {
      //Existing added data pass the added flag to false
      onRemove(e.detail.data.id, false, e.detail.data.value)
    } else {
      //Added data pass the added flag to true
      onRemove(e.detail.tag.__tagifyTagData.__tagId, true, e.detail.data.value)
    }
  }

  return (
    <div className={`form-group product-setup-tagify ${name === 'zip codes' ? '' : 'mb-8'}`}>
      {label && (
        <label className='text-gray-700 fs-6 fw-semibold mb-1' htmlFor={'field-' + name}>
          {label}
        </label>
      )}
      <Tags
        className={className}
        InputMode='input'
        placeholder={`Enter ${name}`}
        value={initialValue}
        onEditUpdated={handleChange}
        onRemove={(e:any) => handleRemove(e)}
        onAdd={handleChange}
        readOnly={enumType === 'COMMODITY' || enumType === 'CUSTOMER_TYPE'}
      />
      {!isEditable ? (
        <span className='text-danger fs-base fw-semibold mt-2'>These fields are not editable</span>
      ) : (
        <span className='text-gray-400 fs-base fw-semibold mt-2 d-block'>
          Add new option to {name}
        </span>
      )}
    </div>
  )
}

export default TagField
